module.exports = __webpack_public_path__ + "static/img/draw_area.663048d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/408/draw_area.png
// module id = 488
// module chunks = 1